module.exports = __webpack_public_path__ + "static/media/12.0a7ed49c.jpg";